module.exports = __webpack_public_path__ + "static/media/landmark-sponsor-logo.6a697bc1.png";